
export const environment = {
	production: true,
	appName: 'PORTAL', // 'LBPortal',
	authLogoUrl: 'assets/css/img/lbportal_logo.png',
	rootLink: 'https://admin.linearbench.com/',
	serviceRootUrl: 'https://api.linearbench.com/',
	esriServiceRootUrl: 'https://arcgis.linearbench.com/arcgis/sharing/rest',
	idleTime: 10000000000000, // 600000,
	//
	appRoot: 'https://www.linearbench.com/', // Root for different apps such as A3I, HPMS, etc.
	featureToggle: {},
	giveRoot: 'https://gis-give.com/ng911/',
	envName: 'prod'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts